// import React, { useEffect, useState } from "react";
// import UserMenu from "../components/UserMenu";
// import Header from "../components/Header";
// import SideMenu from "../components/SideMenu";
// import { useSelector } from "react-redux";
// import API_BASE_URL from "../utilities/ApiConfig";
// import axios from "axios";
// import { toast } from "react-toastify";
// import REPORT_BASE_URL from "../utilities/ReportConfig";

// const EndorsementFinal = () => {
//   const [bookNo, setBookNo] = useState("");
//   const [selectedYear, setSelectedYear] = useState(""); // State for selected year
//   const [registrationYears, setRegistrationYears] = useState([]);
//   const [regNo, setRegNo] = useState(""); // State for reg number
//   const [deedDetails, setDeedDetails] = useState(null); // State to store deed details
//   const [loading, setLoading] = useState(false);

//   const { userDetails } = useSelector((state) => state.auth);
//   console.log(deedDetails);
//   // Fetch registration years based on book number
//   const fetchRegistrationYears = async () => {
//     if (!bookNo) return;

//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${API_BASE_URL}/Master/Virtual_GetBookRegYear?dcode=${userDetails.dcode}&srocode=${userDetails.srocode}&bookno=${bookNo}`
//       );
//       setRegistrationYears(response.data?.regYears || []);
//     } catch (err) {
//       toast.error("Failed to get registration year");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchRegistrationYears();
//   }, [bookNo]); // Fetch years when bookNo changes

//   // Fetch deed details when bookNo, selectedYear, and regNo are selected
//   const fetchDeedDetails = async () => {
//     if (!bookNo || !selectedYear || !regNo) return;

//     try {
//       setLoading(true);
//       const response = await axios.post(
//         `${API_BASE_URL}/Registration/Virtual_getdeed_details`,
//         {
//           dCode: userDetails.dcode,
//           sroCode: userDetails.srocode,
//           year: selectedYear,
//           bookNo: bookNo,
//           regNo: regNo,
//           mode: "Post_REGULIZATION",
//         }
//       );

//       setDeedDetails(response.data.data);
//       console.log("Deed Details:", response.data.data);
//     } catch (err) {
//       // toast.error("Failed to fetch deed details");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchDeedDetails();
//   }, [bookNo, selectedYear, regNo]); // Fetch deed details when values are selected

//   const handlePrintEndorsement = async () => {
//     try {
//       const { deedCode } = deedDetails;

//       // Check if deedcode is in the specified list
//       if (["39", "40", "41", "42", "43"].includes(deedCode)) {
//         toast.error(
//           `Does not require printing the report: ${deedDetails.deedName}`
//         );
//         return;
//       }
//       const reportUrl =
//         `${REPORT_BASE_URL}/Report/EndorsementReport.aspx?` +
//         `pi_docode=${userDetails.dcode}&pi_srocode=${userDetails.srocode}` +
//         `&pi_regyear=${selectedYear}&pi_bookno=${bookNo}` +
//         `&pi_regno=${regNo}&deedcode=${deedDetails?.deedCode}` +
//         `&subdeedcode=${deedDetails?.deedSubCode}&mode=Post_REGULIZATION`;

//       window.open(reportUrl, "_blank");
//     } catch (error) {
//       console.error("Error:", error);
//       toast.error("Failed to open the Endorsement Report.");
//     }
//   };

//   const handlePrintPhoto = async () => {
//     try {
//       if (
//         !userDetails?.dcode ||
//         !userDetails?.srocode ||
//         !selectedYear ||
//         !bookNo ||
//         !regNo
//       ) {
//         alert("Missing required details. Please check your inputs.");
//         return;
//       }

//       const reportUrl = `${REPORT_BASE_URL}/Report/PhotoCertificateReport.aspx?pi_docode=${userDetails.dcode}&pi_srocode=${userDetails.srocode}&pi_regyear=${selectedYear}&pi_bookno=${bookNo}&pi_regno=${regNo}&mode=Post_REGULIZATION`;

//       window.open(reportUrl, "_blank");
//     } catch (error) {
//       console.error("Error opening the report:", error);
//     }
//   };

//   return (
//     <div className="flex flex-row h-screen">
//       <SideMenu className="w-full md:w-64" />
//       <div className="flex-1 flex flex-col overflow-hidden">
//         <Header />

//         <div className="flex flex-1 flex-col md:flex-row overflow-y-auto">
//           <div className="max-w-3xl mx-auto p-6">
//             <h2 className="text-lg font-semibold mb-4">
//               Endorsement & Photo Certificate
//             </h2>

//             <div className="grid grid-cols-3 gap-4 mb-4">
//               {/* Book No Selection */}
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Book No.
//                 </label>
//                 <select
//                   value={bookNo}
//                   onChange={(e) => setBookNo(e.target.value)}
//                   className="w-full p-1.5 border border-[#B1B1B1] rounded-md"
//                 >
//                   <option value="">Select</option>
//                   <option value="1">1</option>
//                   <option value="3">3</option>
//                   <option value="4">4</option>
//                   <option value="6">6</option>
//                 </select>
//               </div>

//               {/* Registration Year Selection */}
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Reg Year
//                 </label>
//                 <select
//                   value={selectedYear}
//                   onChange={(e) => setSelectedYear(e.target.value)}
//                   className="w-full p-1.5 border border-[#B1B1B1] rounded-md"
//                 >
//                   <option value="">Select</option>
//                   {registrationYears.length > 0 ? (
//                     registrationYears.map((year, index) => (
//                       <option key={index} value={year}>
//                         {year}
//                       </option>
//                     ))
//                   ) : (
//                     <option disabled>No years available</option>
//                   )}
//                 </select>
//               </div>

//               {/* Registration Number Input */}
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Reg No.
//                 </label>
//                 <input
//                   type="text"
//                   value={regNo}
//                   onChange={(e) => setRegNo(e.target.value)}
//                   placeholder="Enter"
//                   className="w-full p-1.5 border border-[#B1B1B1] rounded-md"
//                 />
//               </div>
//             </div>

//             {/* Display Deed Details */}

//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">
//                 Deed Name
//               </label>
//               <input
//                 type="text"
//                 value={deedDetails?.deedName || "N/A"}
//                 className="w-full p-1.5 border border-[#B1B1B1] rounded-md"
//               />
//             </div>

//             <div className="mb-6">
//               <label className="block text-sm font-medium mb-1">
//                 Sub-deed Name
//               </label>
//               <input
//                 value={deedDetails?.subDeedName || "N/A"}
//                 className="w-full p-1.5 border border-[#B1B1B1] rounded-md"
//               />
//             </div>

//             <div className="flex justify-center space-x-1 mt-4">
//               <button
//                 onClick={handlePrintEndorsement}
//                 className="w-full bg-blue-500 text-white px-2 py-1.5 rounded-full"
//               >
//                 Endorsement
//               </button>
//               <button
//                 onClick={handlePrintPhoto}
//                 className="w-full bg-blue-500 text-white px-2 py-1.5 rounded-full"
//               >
//                 Photos
//               </button>
//               <button className="w-full bg-blue-500 text-white px-2 py-1.5 rounded-full">
//                 Certificate
//               </button>
//             </div>
//           </div>

//           <div className="hidden md:block w-64 h-full">
//             <UserMenu />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EndorsementFinal;
import React, { useEffect, useState } from "react";
import UserMenu from "../components/UserMenu";
import Header from "../components/Header";
import SideMenu from "../components/SideMenu";
import { useSelector } from "react-redux";
import API_BASE_URL from "../utilities/ApiConfig";
import axios from "axios";
import { toast } from "react-toastify";
import REPORT_BASE_URL from "../utilities/ReportConfig";

const EndorsementFinal = () => {
  const [bookNo, setBookNo] = useState("");
  const [selectedYear, setSelectedYear] = useState(""); // State for selected year
  const [registrationYears, setRegistrationYears] = useState([]);
  const [regNo, setRegNo] = useState(""); // State for reg number
  const [deedDetails, setDeedDetails] = useState(null); // State to store deed details
  const [loading, setLoading] = useState(false);

  const { userDetails } = useSelector((state) => state.auth);
  console.log(deedDetails);
  // Fetch registration years based on book number
  const fetchRegistrationYears = async () => {
    if (!bookNo) return;

    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/Master/Virtual_GetBookRegYear?dcode=${userDetails.dcode}&srocode=${userDetails.srocode}&bookno=${bookNo}`
      );
      setRegistrationYears(response.data?.regYears || []);
    } catch (err) {
      toast.error("Failed to get registration year");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRegistrationYears();
  }, [bookNo]); // Fetch years when bookNo changes

  // Fetch deed details when bookNo, selectedYear, and regNo are selected
  const fetchDeedDetails = async () => {
    if (!bookNo || !selectedYear || !regNo) return;

    try {
      setLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/Registration/Virtual_getdeed_details`,
        {
          dCode: userDetails.dcode,
          sroCode: userDetails.srocode,
          year: selectedYear,
          bookNo: bookNo,
          regNo: regNo,
          mode: "Post_REGULIZATION",
        }
      );

      setDeedDetails(response.data.data);
      console.log("Deed Details:", response.data.data);
    } catch (err) {
      // toast.error("Failed to fetch deed details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeedDetails();
  }, [bookNo, selectedYear, regNo]); // Fetch deed details when values are selected

  const handlePrintEndorsement = async () => {
    try {
      const { deedCode } = deedDetails;

      // Check if deedcode is in the specified list
      if (["39", "40", "41", "42", "43"].includes(deedCode)) {
        toast.error(
          `Does not require printing the report: ${deedDetails.deedName}`
        );
        return;
      }
      const reportUrl =
        `${REPORT_BASE_URL}/Report/EndorsementReport.aspx?` +
        `pi_docode=${userDetails.dcode}&pi_srocode=${userDetails.srocode}` +
        `&pi_regyear=${selectedYear}&pi_bookno=${bookNo}` +
        `&pi_regno=${regNo}&deedcode=${deedDetails?.deedCode}` +
        `&subdeedcode=${deedDetails?.deedSubCode}&rpt_Type=${deedDetails?.appointmentType}&mode=Post_REGULIZATION`;

      window.open(reportUrl, "_blank");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to open the Endorsement Report.");
    }
  };

  const handlePrintCertificate = async () => {
    try {
      if (
        !userDetails?.dcode ||
        !userDetails?.srocode ||
        !selectedYear ||
        !bookNo ||
        !regNo
      ) {
        alert("Missing required details. Please check your inputs.");
        return;
      }

      const reportUrl = `${REPORT_BASE_URL}/Report/CertificateFinal.aspx?pi_dcode=${userDetails.dcode}&pi_srocode=${userDetails.srocode}&pi_regyear=${selectedYear}&pi_bookno=${bookNo}&pi_regno=${regNo}&rpt_Type=${deedDetails?.appointmentType}`;

      window.open(reportUrl, "_blank");
    } catch (error) {
      console.error("Error opening the report:", error);
    }
  };
  const handlePrintPhoto = async () => {
    try {
      if (
        !userDetails?.dcode ||
        !userDetails?.srocode ||
        !selectedYear ||
        !bookNo ||
        !regNo
      ) {
        alert("Missing required details. Please check your inputs.");
        return;
      }

      const reportUrl = `${REPORT_BASE_URL}/Report/PhotoCertificateReport.aspx?pi_docode=${userDetails.dcode}&pi_srocode=${userDetails.srocode}&pi_regyear=${selectedYear}&pi_bookno=${bookNo}&pi_regno=${regNo}&mode=Post_REGULIZATION&rpt_Type=${deedDetails?.appointmentType}`;

      window.open(reportUrl, "_blank");
    } catch (error) {
      console.error("Error opening the report:", error);
    }
  };

  return (
    <div className="flex flex-row h-screen">
      <SideMenu className="w-full md:w-64" />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />

        <div className="flex flex-1 flex-col md:flex-row overflow-y-auto">
          <div className="max-w-3xl mx-auto p-6">
            <h2 className="text-lg font-semibold mb-4">
              Endorsement & Photo Certificate
            </h2>

            <div className="grid grid-cols-3 gap-4 mb-4">
              {/* Book No Selection */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Book No.
                </label>
                <select
                  value={bookNo}
                  onChange={(e) => setBookNo(e.target.value)}
                  className="w-full p-1.5 border border-[#B1B1B1] rounded-md"
                >
                  <option value="">Select</option>
                  <option value="1">1</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="6">6</option>
                </select>
              </div>

              {/* Registration Year Selection */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Reg Year
                </label>
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="w-full p-1.5 border border-[#B1B1B1] rounded-md"
                >
                  <option value="">Select</option>
                  {registrationYears.length > 0 ? (
                    registrationYears.map((year, index) => (
                      <option key={index} value={year}>
                        {year}
                      </option>
                    ))
                  ) : (
                    <option disabled>No years available</option>
                  )}
                </select>
              </div>

              {/* Registration Number Input */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Reg No.
                </label>
                <input
                  type="text"
                  value={regNo}
                  onChange={(e) => setRegNo(e.target.value)}
                  placeholder="Enter"
                  className="w-full p-1.5 border border-[#B1B1B1] rounded-md"
                />
              </div>
            </div>

            {/* Display Deed Details */}

            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">
                Deed Name
              </label>
              <input
                type="text"
                value={deedDetails?.deedName || "N/A"}
                className="w-full p-1.5 border border-[#B1B1B1] rounded-md"
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium mb-1">
                Sub-deed Name
              </label>
              <input
                value={deedDetails?.subDeedName || "N/A"}
                className="w-full p-1.5 border border-[#B1B1B1] rounded-md"
              />
            </div>

            <div className="flex justify-center space-x-1 mt-4">
              <button
                onClick={handlePrintEndorsement}
                className="w-full bg-blue-500 text-white px-2 py-1.5 rounded-full"
              >
                Endorsement
              </button>
              <button
                onClick={handlePrintPhoto}
                className="w-full bg-blue-500 text-white px-2 py-1.5 rounded-full"
              >
                Photos
              </button>
              <button
                onClick={handlePrintCertificate}
                className="w-full bg-blue-500 text-white px-2 py-1.5 rounded-full"
              >
                Certificate
              </button>
            </div>
          </div>

          <div className="hidden md:block w-64 h-full">
            <UserMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EndorsementFinal;
